module.exports = __webpack_public_path__ + "static/img/companyRoom.ed60942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/companyRoom.png
// module id = 5vLU
// module chunks = 2